import React from 'react';
import { ElementGroup } from '@whalecloud/page-builder-core/constant/index';
import Remote from './components/Remote';
import { ReactComponent as PluginSvg } from '@assets/icons/remote-component.svg';
import { getLocale, defaultTarget } from '@utils/util';
import RemoteSettings from './components/RemoteSettings';

export default () => {
  const messages = getLocale();
  return {
    name: 'remoteComponent', // 插件名，不能包含空格,空格用-代替
    group: ElementGroup.CUSTOM, // 插件所在组，默认为ElementGroup.CUSTOM
    target: defaultTarget, // 插件所在目标层级，默认为["column", "row", "form"]
    title: messages['PAGEBUIDER_SETTINGS_PROPERTY_REMOTE_COMPONENT'], // 插件标题
    toolBarPreview: <PluginSvg />, // 插件展示图标，不传则展示文字
    data: {
      componentSettings: {
        url: ""
      },
      settings: {
        width: {
          value: "100%"
        },
      },
      formSettings: {
        label: messages['PAGEBUIDER_SETTINGS_PROPERTY_REMOTE_COMPONENT']
      },
    },
    pluginComponent: Remote, // 插件渲染组件
    pluginSettingComponent: RemoteSettings, // 插件设置项组件
  };
};
